import filterXSS from 'xss';
import DetectRTC from 'detectrtc';

import { LocalStorage } from '@src/services';
import SocketService from '@src/services/SocketService';
import { getDataTimeString, getUUID, isIpad, isTablet } from '@src/utils';

import { IPeerInfo } from '@src/types';

export const getPeerUUID = () => {
  const lS = new LocalStorage();

  if (lS.getItemLocalStorage('peer_uuid')) {
    return lS.getItemLocalStorage('peer_uuid');
  }
  const peer_uuid = getUUID();
  lS.setItemLocalStorage('peer_uuid', peer_uuid);
  return peer_uuid;
};

export const getPeerToken = () => {
  if (window.sessionStorage.peer_token) return window.sessionStorage.peer_token;
  let qs = new URLSearchParams(window.location.search);
  let token = filterXSS(qs.get('token') ?? '');
  let queryToken = '';
  if (token) {
    queryToken = token;
  }
  return queryToken;
};

export const generatePeerInfo = ({
  peerId = SocketService?.getSocketId() ?? '',
  peerName,
  peerUUID = getPeerUUID(),
  peerAudio = false,
  peerVideo = false,
  peerScreen = false,
  peerRecording = false,
  peerImage = '',
}: {
  peerId?: string;
  peerUUID?: string;
  peerName: string;
  peerAudio?: boolean;
  peerVideo?: boolean;
  peerScreen?: boolean;
  peerRecording?: boolean;
  peerImage?: string;
}): IPeerInfo => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isTabletDevice = isTablet(userAgent);
  const isIPadDevice = isIpad(userAgent);
  return {
    join_data_time: getDataTimeString(),
    peer_uuid: peerUUID,
    peer_id: peerId,
    peer_name: peerName,
    peer_image: peerImage,
    peer_token: getPeerToken(),
    peer_presenter: false,
    peer_audio: peerAudio,
    peer_audio_volume: 100,
    peer_video: peerVideo,
    peer_screen: peerScreen,
    peer_recording: peerRecording,
    peer_video_privacy: false,
    peer_hand: false,
    is_desktop_device: !DetectRTC.isMobileDevice && !isTabletDevice && !isIPadDevice,
    is_mobile_device: DetectRTC.isMobileDevice,
    is_tablet_device: isTabletDevice,
    is_ipad_pro_device: isIPadDevice,
    os_name: DetectRTC.osName,
    os_version: DetectRTC.osVersion,
    browser_name: DetectRTC.browser.name,
    browser_version: DetectRTC.browser.version,
    user_agent: userAgent,
  };
};
